import React from 'react'

import { SettingsStoreState } from '../../stores/settings'
import OutgoingMediaQuality from './OutgoingMediaQuality'
import DownloadOnDemand from './DownloadOnDemand'
import DesktopSettingsSwitch from './DesktopSettingsSwitch'
import CoreSettingsSwitch from './CoreSettingsSwitch'
import Autodelete from './Autodelete'
import Backup from './Backup'
import SettingsSeparator from './SettingsSeparator'
import SettingsHeading from './SettingsHeading'
import useTranslationFunction from '../../hooks/useTranslationFunction'
import useDialog from '../../hooks/dialog/useDialog'
import UnblockContacts from '../dialogs/UnblockContacts'
import SettingsButton from './SettingsButton'
import { instanceHidesPublicSuggestions } from '../../utils/slothfulInstanceConfig'

type Props = {
  settingsStore: SettingsStoreState
}

export default function ChatsAndMedia({ settingsStore }: Props) {
  const tx = useTranslationFunction()
  const { openDialog } = useDialog()

  return (
    <>
      <SettingsButton onClick={() => openDialog(UnblockContacts)}>
        {tx('pref_blocked_contacts')}
      </SettingsButton>
      <CoreSettingsSwitch
        settingsKey='mdns_enabled'
        label={tx('pref_read_receipts')}
        description={tx('pref_read_receipts_explain')}
      />
      <DesktopSettingsSwitch
        settingsKey='enterKeySends'
        label={tx('pref_enter_sends')}
        description={tx('pref_enter_sends_explain')}
      />
      <DesktopSettingsSwitch
        settingsKey='stripTrackingLinks'
        label='Remove tracking from links'
        description='Strips known tracking parameters (utm_*, YouTube si=, …) when you paste or open a link'
      />
      {/* When the whole instance hides the suggestions
      (SLOTHFUL_HIDE_PUBLIC_SUGGESTIONS), these toggles are moot —
      hide them too. */}
      {!instanceHidesPublicSuggestions() && (
        <>
          <DesktopSettingsSwitch
            settingsKey='hideNewChatSuggestions'
            label='Hide community suggestions'
            description='Hides the "Public Bots" and "Public Channels" entries in the "New Chat" dialog'
            forkAdded
          />
          <DesktopSettingsSwitch
            settingsKey='publicBotsRemoteLoadConsent'
            label='Load the public bots list without asking'
            description='When off, "Public Bots" shows its disclaimer again and asks before fetching the list from GitHub'
            forkAdded
          />
        </>
      )}
      <OutgoingMediaQuality settings={settingsStore.settings} />
      <DownloadOnDemand settings={settingsStore.settings} />

      <SettingsSeparator />
      <SettingsHeading>{tx('delete_old_messages')}</SettingsHeading>
      <Autodelete settingsStore={settingsStore} />
      <SettingsSeparator />
      <SettingsHeading>{tx('pref_backup')}</SettingsHeading>
      <Backup />
    </>
  )
}
